import React from "react";
import { useNavigate } from "react-router-dom";


interface EmptyPieChartProps {
  paragraph?: React.ReactNode;
  buttonText?: string;
  link: string;
  title?: string;
  icon?: React.ReactNode;
}

export const EmptyPieChart = ({
  paragraph,
  buttonText,
  link,
  title,
  icon,
}: EmptyPieChartProps) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center w-full pb-6">

      <div className="border-b w-full">
        <p className="font-semibold text-left p-4">{title}</p>
      </div>

      <div className="mt-10">
      {icon}
      </div>

      <p className="text-[#344054] text-[14px] text-center font-medium leading-5 my-5">
        {paragraph}
      </p>

      {buttonText && (
        <div
          onClick={() => navigate(link)}
          className="text-[#044E97] text-[14px] leading-5 border border-[#044E97] font-semibold rounded py-2 px-4 cursor-pointer"
        >
          {buttonText}
        </div>
      )}
    </div>
  );
};
